import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Configurateur: React.FC = () => {
    const [email, setEmail] = useState('');
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [activeFeature, setActiveFeature] = useState(0);

    // Animation pour les features
    useEffect(() => {
        const timer = setInterval(() => {
            setActiveFeature((prev) => (prev + 1) % 4);
        }, 3000);
        return () => clearInterval(timer);
    }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (email) {
            setIsSubscribed(true);
            setEmail('');
        }
    };

    const features = [
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                </svg>
            ),
            title: 'Cadre sur mesure',
            description: 'Choisissez votre cadre parmi les meilleures marques : Factor, Specialized, Canyon, Trek...'
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            ),
            title: 'Groupes & Composants',
            description: 'Shimano, SRAM, Campagnolo... Sélectionnez chaque composant selon vos préférences.'
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                </svg>
            ),
            title: 'Finitions personnalisées',
            description: 'Couleurs, finitions, gravures... Créez un vélo qui vous ressemble.'
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
            ),
            title: 'Devis instantané',
            description: 'Visualisez votre vélo en temps réel et obtenez un devis immédiat.'
        }
    ];

    const brands = [
        { name: 'Factor', logo: '/logo configurateur/factor.svg', noInvert: true },
        { name: 'Specialized', logo: '/logo configurateur/specialized-bicycle-components-logo-vector.svg' },
        { name: 'Canyon', logo: '/logo configurateur/Canyon_Bicycles-Logo.wine.svg' },
        { name: 'Trek', logo: '/logo configurateur/Trek_Bicycle_Corporation-Logo.wine.svg' },
        { name: 'Cervélo', logo: '/logo configurateur/cervelo-logo-brandlogos.net_a3bghpxcw.svg' },
        { name: 'BMC', logo: '/logo configurateur/BMC_Switzerland-Logo.wine.svg' },
        { name: 'Pinarello', logo: '/logo configurateur/Pinarello-Logo.wine.svg' },
        { name: 'Colnago', logo: '/logo configurateur/Colnago-Logo.wine.svg' }
    ];

    return (
        <div className="min-h-screen bg-zinc-950">
            <Header />

            {/* Hero Section */}
            <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
                {/* Animated Background */}
                <div className="absolute inset-0">
                    <div className="absolute inset-0 bg-gradient-to-br from-zinc-950 via-zinc-900 to-zinc-950"></div>

                    {/* Gradient Orbs */}
                    <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
                    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
                </div>

                <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-24">
                    {/* Badge */}
                    <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-8">
                        <span className="relative flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                        </span>
                        <span className="text-zinc-300 text-sm font-medium">En cours de développement</span>
                    </div>

                    {/* Main Title */}
                    <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
                        <span className="bg-gradient-to-r from-white via-zinc-300 to-zinc-500 bg-clip-text text-transparent">
                            Configurateur
                        </span>
                        <br />
                        <span className="text-3xl md:text-5xl lg:text-6xl text-zinc-400">
                            Vélo Sur Mesure
                        </span>
                    </h1>

                    <p className="text-xl md:text-2xl text-zinc-400 max-w-3xl mx-auto mb-12 leading-relaxed">
                        Créez le vélo de vos rêves, pièce par pièce.
                        Notre configurateur 2D vous permettra de visualiser et personnaliser
                        chaque détail de votre futur vélo haut de gamme.
                    </p>

                    {/* Coming Soon Badge */}
                    <div className="inline-flex items-center gap-3 bg-gradient-to-r from-zinc-800 to-zinc-900 border border-zinc-700 px-8 py-4 rounded-2xl mb-12">
                        <svg className="w-6 h-6 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                        <span className="text-white font-semibold text-lg">Lancement prévu : Printemps 2026</span>
                    </div>

                    {/* Newsletter Signup */}
                    <div className="max-w-md mx-auto">
                        {isSubscribed ? (
                            <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-2xl p-6 backdrop-blur-sm">
                                <svg className="w-12 h-12 text-emerald-400 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <p className="text-emerald-300 font-semibold">Merci pour votre inscription !</p>
                                <p className="text-zinc-400 text-sm mt-1">Vous serez notifié dès le lancement.</p>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Votre email pour être notifié"
                                    required
                                    className="flex-1 px-5 py-4 bg-white/5 border border-zinc-700 rounded-xl text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-transparent transition-all"
                                />
                                <button
                                    type="submit"
                                    className="px-8 py-4 bg-white text-zinc-900 font-semibold rounded-xl hover:bg-zinc-200 transition-all duration-300 whitespace-nowrap"
                                >
                                    Me notifier
                                </button>
                            </form>
                        )}
                    </div>

                    {/* Scroll indicator */}
                    <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
                        <svg className="w-6 h-6 text-zinc-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                        </svg>
                    </div>
                </div>
            </section>

            {/* Features Preview */}
            <section className="py-24 relative bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 mb-4">
                            Ce qui vous attend
                        </h2>
                        <p className="text-zinc-600 text-lg max-w-2xl mx-auto">
                            Un outil révolutionnaire pour créer le vélo parfait, adapté à vos besoins et vos envies.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {features.map((feature, index) => (
                            <div
                                key={index}
                                className={`relative p-6 rounded-2xl transition-all duration-500 transform-gpu ${index === activeFeature
                                    ? 'bg-zinc-100 ring-2 ring-zinc-400 shadow-xl z-10'
                                    : 'bg-zinc-50 ring-1 ring-zinc-200/50 hover:bg-zinc-100 hover:ring-zinc-300'
                                    }`}
                            >
                                <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-4 transition-colors duration-500 ${index === activeFeature ? 'bg-zinc-900 text-white' : 'bg-zinc-200 text-zinc-600'
                                    }`}>
                                    {feature.icon}
                                </div>
                                <h3 className="text-xl font-bold text-zinc-900 mb-2">{feature.title}</h3>
                                <p className="text-zinc-600 text-sm leading-relaxed">{feature.description}</p>

                                <div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-zinc-700 to-zinc-900 rounded-b-2xl transition-opacity duration-500 ${index === activeFeature ? 'opacity-100' : 'opacity-0'}`}></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Brands Section */}
            <section className="py-16 bg-zinc-900/50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <p className="text-center text-zinc-500 mb-10 uppercase tracking-widest text-sm">
                        Les plus grandes marques disponibles
                    </p>
                    <div className="flex justify-center items-center gap-6 md:gap-10 lg:gap-14">
                        {brands.map((brand, index) => (
                            <div
                                key={index}
                                className="w-16 h-8 md:w-24 md:h-10 lg:w-28 lg:h-12 flex-shrink-0 flex items-center justify-center opacity-60 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0"
                            >
                                <img
                                    src={brand.logo}
                                    alt={brand.name}
                                    className={`w-full h-full object-contain ${(brand as any).noInvert ? 'brightness-200' : 'invert'}`}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 2D Preview Mockup */}
            <section className="py-24">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div>
                            <span className="inline-block px-3 py-1 bg-blue-500/10 text-blue-400 text-sm font-medium rounded-full mb-4">
                                Aperçu exclusif
                            </span>
                            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                                Visualisation 2D en temps réel
                            </h2>
                            <p className="text-zinc-400 text-lg mb-8 leading-relaxed">
                                Notre configurateur intégrera une technologie de visualisation 2D avancée.
                                Faites pivoter, zoomez et explorez chaque détail de votre vélo personnalisé
                                avant de passer commande.
                            </p>

                            <ul className="space-y-4">
                                {[
                                    'Rotation 360° du vélo',
                                    'Zoom sur les composants',
                                    'Changement de couleurs en temps réel',
                                    'Export du rendu en haute qualité'
                                ].map((item, index) => (
                                    <li key={index} className="flex items-center gap-3 text-zinc-300">
                                        <svg className="w-5 h-5 text-emerald-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                        </svg>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="relative">
                            {/* Mockup Frame */}
                            <div className="relative bg-gradient-to-br from-zinc-800 to-zinc-900 rounded-3xl p-4 border border-zinc-700 shadow-2xl">
                                <div className="aspect-video bg-zinc-950 rounded-2xl overflow-hidden relative">
                                    {/* Fake 2D Viewer */}
                                    <div className="absolute inset-0 flex items-center justify-center">
                                        <div className="text-center">
                                            <div className="w-24 h-24 border-4 border-zinc-700 border-t-white rounded-full animate-spin mx-auto mb-4"></div>
                                            <p className="text-zinc-500 text-sm">Chargement du configurateur 2D...</p>
                                        </div>
                                    </div>

                                    {/* Overlay gradient */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/80 to-transparent"></div>

                                    {/* Coming soon overlay */}
                                    <div className="absolute inset-0 flex items-center justify-center backdrop-blur-sm">
                                        <div className="bg-zinc-900/90 px-6 py-3 rounded-full border border-zinc-700">
                                            <span className="text-white font-medium">Bientôt disponible</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Fake toolbar */}
                                <div className="flex items-center justify-between mt-4 px-2">
                                    <div className="flex gap-2">
                                        {['bg-zinc-700', 'bg-blue-500', 'bg-red-500', 'bg-emerald-500'].map((color, i) => (
                                            <div key={i} className={`w-6 h-6 rounded-full ${color} opacity-50`}></div>
                                        ))}
                                    </div>
                                    <div className="flex gap-2">
                                        <div className="w-8 h-8 bg-zinc-800 rounded-lg"></div>
                                        <div className="w-8 h-8 bg-zinc-800 rounded-lg"></div>
                                        <div className="w-8 h-8 bg-zinc-800 rounded-lg"></div>
                                    </div>
                                </div>
                            </div>

                            {/* Decorative elements */}
                            <div className="absolute -top-4 -right-4 w-24 h-24 bg-blue-500/20 rounded-full blur-2xl"></div>
                            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-purple-500/20 rounded-full blur-2xl"></div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Process Section */}
            <section className="py-24 bg-zinc-900/50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                            Comment ça fonctionne ?
                        </h2>
                        <p className="text-zinc-400 text-lg">
                            Un processus simple en 4 étapes pour créer votre vélo idéal.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                        {[
                            { step: '01', title: 'Choisir le cadre', desc: 'Sélectionnez votre cadre et sa taille' },
                            { step: '02', title: 'Composants', desc: 'Groupe, roues, guidon, selle...' },
                            { step: '03', title: 'Personnalisation', desc: 'Couleurs et finitions sur mesure' },
                            { step: '04', title: 'Commande', desc: 'Validez et suivez votre montage' }
                        ].map((item, index) => (
                            <div key={index} className="text-center">
                                <div className="text-6xl font-bold text-zinc-800 mb-4">{item.step}</div>
                                <h3 className="text-xl font-bold text-white mb-2">{item.title}</h3>
                                <p className="text-zinc-500 text-sm">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-24 bg-white">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 mb-6">
                        En attendant le configurateur...
                    </h2>
                    <p className="text-zinc-600 text-lg mb-10">
                        Notre équipe d'experts est disponible pour vous accompagner dans votre projet de vélo sur mesure.
                        Prenez rendez-vous pour discuter de vos besoins.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            to="/contact"
                            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-zinc-900 text-white font-semibold rounded-xl hover:bg-zinc-800 transition-all"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                            </svg>
                            Nous contacter
                        </Link>
                        <Link
                            to="/devis-atelier"
                            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-zinc-900 font-semibold rounded-xl border-2 border-zinc-900 hover:bg-zinc-100 transition-all"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            Demander un devis montage
                        </Link>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Configurateur;
